import styled from 'styled-components';

import { rSize } from '../utils';

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .progress-container {
    height: 3px;
    overflow: hidden;
  }

  .content {
    padding: ${rSize(30)};
    flex-grow: 1;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;

    .tab {
      height: 100%;

      > div {
        height: 100%;
      }
    }
  }
`;
